import { render, staticRenderFns } from "./add_edit_pay_setting.vue?vue&type=template&id=7749a31a&scoped=true&"
import script from "./add_edit_pay_setting.vue?vue&type=script&lang=ts&"
export * from "./add_edit_pay_setting.vue?vue&type=script&lang=ts&"
import style0 from "./add_edit_pay_setting.vue?vue&type=style&index=0&id=7749a31a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7749a31a",
  null
  
)

export default component.exports